import { UserType } from '@pages/dashboard/SignUp/SignUp';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@store/utils';

export const USER_API_URL = process.env.REACT_APP_API_BASE_URL;
interface User {
  preferred_name?: string;
  phone?: string;
  mailing_address?: string;
  ein?: string;
  last_login?: Date;
}
export interface Payment {
  policy: number;
  price: number;
  due_date: string;
  status: string;
  paid_date: string;
  automatic_payments: boolean;
}
export interface SingUp {
  role: UserType;
  email: string;
}
export interface Payout {
  policy: number;
  issue: number;
  issue_date: string;
  payout_status: string;
  payout_date: string;
  payout_amount: number;
  payout_type: string;
  confirmation_number: number;
}
export const userApi = createApi({
  reducerPath: 'user',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getUserProfile: builder.query<any, any>({
      query: () => ({
        url: `profile/`,
      }),
    }),
    updateUserProfile: builder.mutation<any, User>({
      query: (payload) => ({
        url: `profile/`,
        method: 'PATCH',
        body: {
          ...payload,
        },
      }),
    }),
    signUpSetRole: builder.mutation<any, SingUp>({
      query: (payload) => ({
        url: `sign_up/`,
        method: 'POST',
        body: {
          ...payload,
        },
      }),
    }),
    getMe: builder.query<any, any>({
      query: () => ({
        url: `me`,
      }),
    }),
    getProducerLicenses: builder.query<any, any>({
      query: () => ({
        url: `licenses/`,
      }),
    }),
    getUserPaymentHistory: builder.query<Payment[], any>({
      query: () => ({
        url: `payment_history/`,
      }),
    }),
    getUserPayoutHistory: builder.query<Payout[], any>({
      query: () => ({
        url: `payout_history/`,
      }),
    }),
    updateLastLogin: builder.mutation<any, void>({
      query: () => ({
        url: `update_last_login/`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useSignUpSetRoleMutation,
  useLazyGetMeQuery,
  useLazyGetProducerLicensesQuery,
  useGetUserPaymentHistoryQuery,
  useGetUserPayoutHistoryQuery,
  useUpdateLastLoginMutation,
} = userApi;
